(function() {

    'use strict';

    angular.module('app').config(clientsUrlConfig);

    clientsUrlConfig.$inject = ['$routeProvider', '$locationProvider'];

    function clientsUrlConfig($routeProvider, $locationProvider) {
        $routeProvider.
        when('/clients/company/details', {
            templateUrl: '/templates/pages/client/company/details.html',
            controller: 'ClientCompanyController',
            controllerAs: 'cl',
            params: {
                parent: 'client',
                subParent: 'onboardNewClient',
                htmlTitle: 'Client - Company',
                pageTitle: 'Client - Company',
                icon: 'fa fa-pencil'
            }
        }).
        when('/clients/company/details/:companyId', {
            templateUrl: '/templates/pages/client/company/details.html',
            controller: 'ClientCompanyController',
            controllerAs: 'cl',
            params: {
                parent: 'client',
                subParent: 'companySearch',
                htmlTitle: 'Client - Company',
                pageTitle: 'Client - Company',
                icon: 'fa fa-pencil'
            }
        }).

        when('/clients/:companyId/list', {
            templateUrl: '/templates/pages/client/list.html',
            controller: 'ClientCompaniesController',
            params: {
                parent: 'client',
                subParent: 'companySearch',
                htmlTitle: 'Client - Details',
                pageTitle: 'Client - Details',
                deepMenuParent: {
                    itemText: 'Client - Company',
                    url: '/clients/company/details/:companyId',
                }
            }
        }).
        when('/clients/:companyId/group/:id?', {
            templateUrl: '/templates/pages/client/group/details.html',
            controller: 'ClientGroupController',
            controllerAs: 'cl',
            params: {
                parent: 'client',
                subParent: 'companySearch',
                htmlTitle: 'Client - Group',
                pageTitle: 'Client - Group',
                icon: 'fa fa-pencil',
                deepMenuParent: {
                    itemText: 'Client - Details',
                    url: '/clients/:companyId/list',
                }
            }
        }).
        when('/clients/:companyId/group/:groupId/account', {
            templateUrl: '/templates/pages/client/account/details.html',
            controller: 'ClientAccountsController',
            controllerAs: 'cl',
            params: {
                parent: 'client',
                subParent: 'companySearch',
                htmlTitle: 'Client - Account',
                pageTitle: 'Client - Account',
                icon: 'fa fa-pencil',
                deepMenuParent: {
                    itemText: 'Client - Group',
                    url: '/clients/:companyId/group/:groupId',
                }
            }
        }).
        when('/clients/:companyId/location/:locationId?', {
            templateUrl: '/templates/pages/client/location/details.html',
            controller: 'ClientLocationController',
            controllerAs: 'cl',
            params: {
                parent: 'client',
                subParent: 'companySearch',
                htmlTitle: 'Client - Office/Location',
                pageTitle: 'Client - Office/Location',
                icon: 'fa fa-pencil',
                customHeader: true,
                deepMenuParent: {
                    itemText: 'Client - Details',
                    url: '/clients/:companyId/list',
                }
            }
        }).
        when('/clients/:companyId/location/:locationId/account', {
            templateUrl: '/templates/pages/client/account/details.html',
            controller: 'ClientAccountsController',
            controllerAs: 'cl',
            params: {
                parent: 'client',
                subParent: 'companySearch',
                htmlTitle: 'Client - Account',
                pageTitle: 'Client - Account',
                icon: 'fa fa-pencil',
                deepMenuParent: {
                    itemText: 'Client - Office/Location',
                    url: '/clients/:companyId/location/:locationId?',
                }
            }
        }).
        when('/clients/:companyId/account/:id?', {
            templateUrl: '/templates/pages/client/account/details.html',
            controller: 'ClientAccountsController',
            controllerAs: 'cl',
            params: {
                parent: 'client',
                subParent: 'companySearch',
                htmlTitle: 'Client - Account',
                pageTitle: 'Client - Account',
                icon: 'fa fa-pencil',
                deepMenuParent: {
                    itemText: 'Client - Details',
                    url: '/clients/:companyId/list',
                }
            }
        });


        // remove this routing in the future
        // when('/clients/company-list', {
        //     templateUrl: '/templates/pages/client/list.html',
        //     controller: 'ClientCompaniesController',
        //     params: {
        //         parent: 'client',
        //         subParent: 'companySearch',
        //         htmlTitle: 'Clients',
        //         pageTitle: 'Clients'
        //     }
        // }).
        // when('/clients/group/details', {
        //     templateUrl: '/templates/pages/client/group/details.html',
        //     controller: 'ClientGroupController',
        //     controllerAs: 'cl',
        //     params: {
        //         parent: 'client',
        //         subParent: 'companySearch',
        //         htmlTitle: 'Client - Group',
        //         pageTitle: 'Client - Group',
        //         icon: 'fa fa-pencil'
        //     }
        // }).
        // when('/clients/location/details', {
        //     templateUrl: '/templates/pages/client/location/details.html',
        //     controller: 'ClientLocationController',
        //     controllerAs: 'cl',
        //     params: {
        //         parent: 'client',
        //         subParent: 'companySearch',
        //         htmlTitle: 'Client - Office/Location',
        //         pageTitle: 'Client - Office/Location',
        //         icon: 'fa fa-pencil'
        //     }
        // }).
        // when('/clients/account/details', {
        //     templateUrl: '/templates/pages/client/account/details.html',
        //     controller: 'ClientAccountsController',
        //     controllerAs: 'cl',
        //     params: {
        //         parent: 'client',
        //         subParent: 'companySearch',
        //         htmlTitle: 'Client - Account',
        //         pageTitle: 'Client - Account',
        //         icon: 'fa fa-pencil'
        //     }
        // }).
        // when('/clients/company/onboarding', {
        //     templateUrl: '/templates/pages/client/company/onboarding-documents.html',
        //     controller: 'ClientCompanyOnboardingController',
        //     params: {
        //         parent: 'client',
        //         htmlTitle: 'BBA Mastro OnBoarding Documents',
        //         pageTitle: 'BBA Mastro OnBoarding Documents',
        //         icon: 'fa fa-loop'
        //     }
        //});

        $locationProvider.html5Mode({
            enabled: true,
            requireBase: false
        });
    }

})();



// WEBPACK FOOTER //
// ./js/urls/client.js